import muiTheme from './theme';
import colors from './colors';
import shadows from './shadows';
import breakpoints from './breakpoints';

export const darkTheme = {
  background: colors.darkBG,
  sectionBg: colors.sectionBG,
  text: colors.white,
};

export const lightTheme = {
  background: colors.lightBG,
  sectionBg: colors.gray,
  text: colors.black,
};

const theme = {
  ...muiTheme,
  colors,
  shadows,
  breakpoints,
};

export default theme;
